export default __webpack_public_path__ + "static/button-action-dont-fd78f3af09b97629f093f90acded7bd1.png";